import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaForm from 'Components/ComponentLibrary/Organisms/MetaForm';

const styles = () => ({
  root: {},
});

const Default = ({
  className,
  classes,
  collection,
}) => {
  return (
    <MetaForm
      className={classNames(classes.root, className)}
      collection={collection}
    />
  );
};

Default.defaultProps = {
  className: '',
};

Default.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  collection: PropTypes.object.isRequired,
};

export default withStyles(styles)(Default);
